const SortAnswer = ({ ...props }) => {
    const answerChoices = props.answerChoices ?? []
    const userAnswer = props.userAnswer.answer_data ? JSON.parse(props.userAnswer.answer_data ) : []
    const pointScored = Number( props.info.quizPointsScored ?? "0" )

    /**
     * TODO: know how to parse the userAnswer; for now, we can't display what's right or wrong because the answer data is decrypted;
     */
    return (
        <div className={`msync-question-container__answer__sortanswer`}>
            {
                answerChoices.map((choice, index) => {
                    return (
                        <input type='text' value={choice._answer ?? ""} key={index} disabled />
                    )
                })
            }
        </div>
    )
}

export default SortAnswer